import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackItemCardClicked = () => useTrackConversion({ goal: KameleoonGoalData.ItemCardClicked });
